export default "/8522fe2631ecefb1e3967be9883671f05392a386/08ee3b32e72dd5b2b700754671ea2016.svg";